import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import {
  formatEnvelopeUsageSummary,
  isUsageNearLimit,
  shouldShowSubscriptionUsage,
} from '../../utils/subscription';
import { formatDateUTC } from '../../utils/dateFormat';

const UsageBanner = () => {
  const subscription = useSelector((state) => state.subscription?.userSubscription);
  const { user } = useSelector((state) => state.auth);
  const isOrgAdmin = Boolean(
    user?.is_organization_admin ?? user?.is_organization_owner
  );

  if (!shouldShowSubscriptionUsage(subscription)) return null;

  const usageLine = formatEnvelopeUsageSummary(subscription, formatDateUTC);
  if (!usageLine) return null;

  const nearLimit = isUsageNearLimit(subscription.usage, 'envelopes');
  const status = (subscription.subscriptionStatus || '').toLowerCase();
  const statusWarning = status && status !== 'active';

  if (!nearLimit && !statusWarning) return null;

  const variant = statusWarning ? 'warning' : 'info';

  return (
    <Alert variant={variant} className="usage-banner py-2 px-3 mb-0 rounded-0 border-0">
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
        <span className="small mb-0">
          {statusWarning && subscription.subscriptionStatus && (
            <strong className="me-2 text-capitalize">
              Subscription: {subscription.subscriptionStatus.replace(/_/g, ' ')}
            </strong>
          )}
          {usageLine}
          {subscription.planName && (
            <span className="text-muted ms-1">({subscription.planName})</span>
          )}
          {nearLimit && !isOrgAdmin && (
            <span className="text-muted ms-1">
              Ask an organization admin to upgrade the plan.
            </span>
          )}
        </span>
        {nearLimit && isOrgAdmin && (
          <Link to="/plans" className="btn btn-sm btn-warning">
            Upgrade
          </Link>
        )}
      </div>
    </Alert>
  );
};

export default UsageBanner;
